import { IGetProcessedIngredients } from './types'

export const getProcessedIngredientVars: IGetProcessedIngredients = {
  state: {
    in: ['Unpublished', 'Published'],
  },
}
